import BannerFlush from 'components/Content/BannerLayout/BannerFlush/BannerFlush';

export default BannerFlush;
